/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useState } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { fetchInvoices } from "../../../../state/thunks/account";
import {
  fetchInvoiceConfig,
  fetchAccountRevenueShare,
  fetchSiteRevenueShare
} from "../../../../state/thunks/settings";

// material
import { Page, Content, InlineMessage } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";
import Invoice from "./invoice/invoice";
import Advanced from "./advanced/advanced";
import Payment from "./payment/payment";
import SettingsHeader from "../settingsHeader";
import SectionLoader from "../../../../material/sectionloader/sectionloader";

// styles
import injectSheet from "react-jss";
import styles from './billing_styles';

// static
const INFO_MESSAGE = "Please contact your account manager to enable invoice access"

/* ========== ~~~~~~~~~~ BILLINGS PAGE ~~~~~~~~~~ ========== */
const BillingPage = injectSheet(styles)((props) => {
    const dispatch = useDispatch();
    const {
      account: {
        invoices
      },
      settings: {
        invoiceConfig: {
          showInvoices
        }
      },
      session: {
        accountUUID,
        mocked, 
        permissions
      }
    } = useSelector((state) => state);
    const updateStatus = useSelector((state) => state.settings.advancedUpdateStatus)
    const query = useSelector((state) => state.router.location.query)
    const [lastUpdated, setLastUpdated] = useState()

    useEffect(() => {
      if (!accountUUID) return;
      const year = query.year ? parseInt(query.year) : new Date().getFullYear();
      const localeDate = new Date().toISOString().split('T')[0]
      dispatch(fetchInvoices({accountUUID, year}))
      dispatch(fetchAccountRevenueShare({localeDate, accountUUID}))
      dispatch(fetchSiteRevenueShare({localeDate, accountUUID}))
      dispatch(fetchInvoiceConfig(accountUUID))
    }, [dispatch, accountUUID])

    useEffect(() => {
      setLastUpdated(Math.max(...invoices.map(o => o.updatedAt)))
    }, [invoices])

    return (
        <Page>
          <SettingsHeader />
          <Content>
            <PageHeader title={'Settings'} subtitle={'Billing'} dataTip={true} lastUpdatedTimestamp={lastUpdated}/>
            <PageContent>
                {/*if logged in as publisher and not show invoices then show just message */}
                {!mocked && !showInvoices && <InlineMessage icon={'exclamation-triangle'}
                                                            message={INFO_MESSAGE}
                                                            variant={'neutral'}/>}
                <Invoice/>
                {permissions.includes('settings.paymentInfo') && <Payment/>}
                {mocked && <>
                    {updateStatus === 'pending'
                        ? <SectionLoader/>
                        : <Advanced/>}
                </>}
            </PageContent>
          </Content>
        </Page>
    );
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default BillingPage;